import { Button } from "src/@/components/ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "src/@/components/ui/dropdown-menu"
import Iconify from "src/components/Iconify"


export function SupervisaoExport({onExportListChats, onExportListChatsPrimeiroContato}) {
    
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="outline"
                    size="sm"
                    className="h-9 mt-0.5 gap-1 text-sm"
                >
                    Exportar
                    <Iconify icon="iconamoon:arrow-down-2-bold" className="w-4 h-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
            
                <DropdownMenuItem onClick={onExportListChats}>
               Exportar chats (.xlsx)
                 </DropdownMenuItem>
                 <DropdownMenuItem onClick={onExportListChatsPrimeiroContato}>
               Exportar chats primeiro contato (.xlsx)
                 </DropdownMenuItem>

            </DropdownMenuContent>
        </DropdownMenu>
    )
}





